import axios from "axios";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { actions } from "../model";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";

function TokenRedirect() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const reduxObject = useSelector((state) => state.user?.redux_object);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const access_token = params.get("token");
    const email = params.get("email");

    if (access_token && email) {
      localStorage.setItem("access_token", access_token);
      localStorage.setItem("email", email);

      dispatch(actions.loginLexiaTools(access_token, email));
    }
  }, [location, dispatch]);

  useEffect(() => {
    if (reduxObject?.accessToken) {
      navigate("/aml/moduli-in-raccolta");
    }
  }, [reduxObject]);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 2000,
      }}
    >
      <CircularProgress sx={{ color: "#1b2838" }} />
    </div>
  );
}

export default TokenRedirect;
